<template>
  <div style="background-color: #edf4fc;">
    <div style="overflow: hidden;">
      <div class="celebrity-content">
        <div style="overflow: hidden;border: 1px dashed rgb(223, 221, 221);margin-bottom: 0.1rem;">
          <el-row :gutter="10" style="border-bottom: 1px dashed rgb(223, 221, 221);">
            <el-col :span="12">
              <div>
                <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据公司名称搜索招聘信息：</div>
                <div class="content-input">
                  <el-input v-model="companyRecruit" placeholder="请输入公司名称" class="content-input-el" clearable @keyup.enter.native="companyRecruitFind()"></el-input>
                  <el-button type="primary" style="height: 0.34rem; margin-left: 0.15rem;" @click="companyRecruitFind()">搜索</el-button>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="border-left: 1px dashed rgb(223, 221, 221);padding-bottom: 0.05rem;">
              <div>
                <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据招聘名称搜索招聘信息：</div>
                <div class="content-input">
                  <el-input v-model="nameRecruit" placeholder="请输入招聘名称" class="content-input-el" clearable @keyup.enter.native="nameRecruitFind()"></el-input>
                  <el-button type="primary" style="height: 0.34rem; margin-left: 0.15rem;" @click="nameRecruitFind()">搜索</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <div>
            <div style="margin: 0.05rem; color: #4f2f4f">根据查询条件搜索招聘信息：</div>
            <div class="content-table">
              <div class="content-table-1">
                <div class="content-table-11">公司所在地：</div>
                <div class="content-table-12">
                  <el-radio-group v-model="idProvinceRecruit" @change="changeSelectProvinceRecruit">
                      <el-radio label="全部" style="margin-right: 0.13rem; margin-bottom: 0.1rem">全部</el-radio>
                      <el-radio label="北京" style="margin-right: 0.13rem; margin-bottom: 0.1rem">北京</el-radio>
                      <el-radio label="天津" style="margin-right: 0.13rem; margin-bottom: 0.1rem">天津</el-radio>
                      <el-radio label="河北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河北</el-radio>
                      <el-radio label="山西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山西</el-radio>
                      <el-radio label="内蒙古" style="margin-right: 0.13rem; margin-bottom: 0.1rem">内蒙古</el-radio>
                      <el-radio label="辽宁" style="margin-right: 0.13rem; margin-bottom: 0.1rem">辽宁</el-radio>
                      <el-radio label="吉林" style="margin-right: 0.13rem; margin-bottom: 0.1rem">吉林</el-radio>
                      <el-radio label="黑龙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">黑龙江</el-radio>
                      <el-radio label="上海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">上海</el-radio>
                      <el-radio label="江苏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江苏</el-radio>
                      <el-radio label="浙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">浙江</el-radio>
                      <el-radio label="安徽" style="margin-right: 0.13rem; margin-bottom: 0.1rem">安徽</el-radio>
                      <el-radio label="福建" style="margin-right: 0.13rem; margin-bottom: 0.1rem">福建</el-radio>
                      <el-radio label="江西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江西</el-radio>
                      <el-radio label="山东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山东</el-radio>
                      <el-radio label="河南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河南</el-radio>
                      <el-radio label="湖北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖北</el-radio>
                      <el-radio label="湖南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖南</el-radio>
                      <el-radio label="广东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广东</el-radio>
                      <el-radio label="广西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广西</el-radio>
                      <el-radio label="海南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">海南</el-radio>
                      <el-radio label="重庆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">重庆</el-radio>
                      <el-radio label="四川" style="margin-right: 0.13rem; margin-bottom: 0.1rem">四川</el-radio>
                      <el-radio label="贵州" style="margin-right: 0.13rem; margin-bottom: 0.1rem">贵州</el-radio>
                      <el-radio label="云南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">云南</el-radio>
                      <el-radio label="西藏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">西藏</el-radio>
                      <el-radio label="陕西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">陕西</el-radio>
                      <el-radio label="甘肃" style="margin-right: 0.13rem; margin-bottom: 0.1rem">甘肃</el-radio>
                      <el-radio label="青海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">青海</el-radio>
                      <el-radio label="宁夏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">宁夏</el-radio>
                      <el-radio label="新疆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">新疆</el-radio>
                      <el-radio label="香港" style="margin-right: 0.13rem; margin-bottom: 0.1rem">香港</el-radio>
                      <el-radio label="澳门" style="margin-right: 0.13rem; margin-bottom: 0.1rem">澳门</el-radio>
                      <el-radio label="台湾" style="margin-right: 0.13rem; margin-bottom: 0.1rem">台湾</el-radio>
                      <el-radio label="暂无" style="margin-right: 0.13rem; margin-bottom: 0.1rem">暂无</el-radio>
                    </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="padding: 0.1rem;border: 1px dashed rgb(223, 221, 221);" >
          <el-collapse>
            <el-collapse-item
              v-for="recruit in dataRecruit"
              :key="recruit.id"
              :title="recruit.name +  (recruit.company !== '' ? '（' + recruit.company + '）' : '') "
              :name="recruit.id"
            >
              <div style="background-color: rgb(228, 255, 228);padding: 0.06rem;">
                <div v-if="recruit.company">
                  <span>公司名称：</span>
                  <span>{{ recruit.company }}</span>
                </div>
                <div v-if="recruit.content">
                  <span>招聘内容：</span>
                  <p style="width: 100%;text-indent: 0.26rem;" v-html="recruit.content"></p>
                </div>
                <div style="overflow: hidden;">
                  <div style="float: left;width: 2rem;">
                    <p v-if="recruit.time">发布时间：{{ recruit.time }}</p>
                    <p v-if="recruit.address">公司地址：{{ recruit.address }}</p>
                  </div>
                  <a :href="recruit.link" v-if="recruit.link" target="_blank" style="float: right;">
                    <el-tag type="danger" style="margin-left: 0.1rem;margin-top: 0.08rem;">招聘链接</el-tag>
                  </a>
                  <a href="javascript:void(0);" @click="downloadRecruit(recruit)" v-if="recruit.file" style="float: right;">
                    <el-tag type="danger" style="margin-left: 0.1rem;margin-top: 0.08rem;">文件下载</el-tag>
                  </a>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div style="padding-top: 0.1rem;">
            <el-pagination :current-page="currentPageRecruit" :page-size="pageSizeRecruit" background layout="prev, pager, next" :total="totalRecruit" @current-change="handleCurrentChangeRecruit" />
          </div>
        </div>
      </div>

      <div class="projects">
        <div class="projects-div">
          <div class="news">MBA创业项目</div>
          <div style="overflow: hidden;border: 1px dashed rgb(223, 221, 221);margin-bottom: 0.1rem;">
            <div style="margin-bottom: 0.1rem;">
              <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据项目名称搜索项目信息：</div>
              <div class="content-input">
                <el-input v-model="nameProject" placeholder="请输入项目名称" class="content-input-el" clearable @keyup.enter.native="nameProjectFind()"></el-input>
                <el-button type="primary" style="height: 0.34rem; margin-left: 0.2rem" @click="nameProjectFind()">搜索</el-button>
              </div>
            </div>
          </div>
          <div class="projects-div-data" v-for="project in dataProject" :key="project.id">
            <div class="projects-div-data-name">
              <div style="overflow: hidden;margin-bottom: 0.05rem;color: blue;" v-if="project.name">
                <span>
                  {{ project.name }}
                  <span v-if="project.company">（{{ project.company }}）</span>
                </span>
              </div>
              <div style="overflow: hidden;" v-if="project.content">
                <span style="float: left;">项目内容：</span>
                <p style="float: left;width: 2.25rem;" v-html="project.content"></p>
              </div>
              <div style="overflow: hidden;">
                <div style="float: left;width: 2rem;">
                  <p v-if="project.time">发布时间：{{ project.time }}</p>
                  <p v-if="project.time">项目地址：{{ project.address }}</p>
                </div>
                <a :href="project.link" v-if="project.link" target="_blank" style="float: right;">
                  <el-tag style="margin-left: 0.1rem">链接跳转</el-tag>
                </a>
                <a href="javascript:void(0);" @click="downloadProject(project)" v-if="project.file" style="float: right;">
                  <el-tag style="margin-left: 0.1rem">文件下载</el-tag>
                </a>
              </div>
            </div>
          </div>
          <div style="padding-top: 0.05rem;">
            <el-pagination :current-page="currentPageProject" :page-size="pageSizeProject" background layout="prev, pager, next" :total="totalProject" @current-change="handleCurrentChangeProject" />
          </div>
        </div>
        <div class="projects-div">
          <div class="news">留言板</div>
          <div class="projects-div-board">
            <el-form ref="formMessageUpdate" :model="formMessageUpdate" label-width="0.5rem" label-position="left">
              <el-form-item label="姓名：">
                <el-input v-model="formMessageUpdate.name" placeholder="必填"></el-input>
              </el-form-item>
              <el-form-item label="邮箱：">
                <el-input v-model="formMessageUpdate.email" placeholder="选填"></el-input>
              </el-form-item>
              <el-form-item label="电话：">
                <el-input v-model="formMessageUpdate.phone" placeholder="必填"></el-input>
              </el-form-item>
              <el-form-item label="内容：">
                <el-input type="textarea" :rows="5" v-model="formMessageUpdate.content" placeholder="选填"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="onSubmitMessage" style="width: 0.82rem; height: 0.36rem; font-size: 0.13rem; margin-left: 0.1rem">提交信息</el-button>
                <el-button type="warning" @click="onClearMessage" style="width: 0.82rem; height: 0.36rem; font-size: 0.13rem; margin-left: 0.55rem">清空内容</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { selectRecruit, SelectRecruitCompany, SelectRecruitName, filesDownloadByIdRecruit } from '@/api/recruit/recruitAPI'
import { selectProject, SelectProjectCompany, SelectProjectName, filesDownloadByIdProject } from '@/api/recruit/projectAPI'
import { insertMessage } from '@/api/recruit/messageAPI'

export default {
  name: 'Recruit',
  data() {
    return {
      dataRecruit: [],
      fileListRecruit: [],
      nameRecruit: '',
      companyRecruit: '',
      idProvinceRecruit: '全部',
      currentPageRecruit: 1,
      pageSizeRecruit: 18,
      totalRecruit: 1,
      idButtonRecruit: 0,
      dataProject: [],
      nameProject: '',
      companyProject: '',
      idProvinceProject: '全部',
      currentPageProject: 1,
      pageSizeProject: 6,
      totalProject: 1,
      idButtonProject: 0,
      formMessageUpdate: {
        name: '',
        email: '',
        phone: '',
        content: ''
      }
    }
  },
  created() {
    this.selectRecruitFind()
    this.selectProjectFind()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async selectRecruitFind() {
      const { data: res } = await selectRecruit(this.idProvinceRecruit, this.currentPageRecruit, this.pageSizeRecruit)
      this.dataRecruit = res.data[2]
      this.totalRecruit = res.data[0]
      this.idButtonRecruit = 3
      for (let i = 0; i < this.dataRecruit.length; i = i + 1) {
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
    },
    async companyRecruitFind() {
      this.currentPageRecruit = 1
      const { data: res } = await SelectRecruitCompany(this.companyRecruit, this.currentPageRecruit, this.pageSizeRecruit)
      this.dataRecruit = res.data[2]
      this.totalRecruit = res.data[0]
      this.idButtonRecruit = 2
      for (let i = 0; i < this.dataRecruit.length; i = i + 1) {
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
    },
    async nameRecruitFind() {
      const { data: res } = await SelectRecruitName(this.nameRecruit, this.currentPageRecruit, this.pageSizeRecruit)
      this.dataRecruit = res.data[2]
      this.totalRecruit = res.data[0]
      this.idButtonRecruit = 1
      for (let i = 0; i < this.dataRecruit.length; i = i + 1) {
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
    },
    async changeSelectProvinceRecruit() {
      this.currentPageRecruit = 1
      const { data: res } = await selectRecruit(this.idProvinceRecruit, this.currentPageRecruit, this.pageSizeRecruit)
      this.dataRecruit = res.data[2]
      this.totalRecruit = res.data[0]
      this.idButtonRecruit = 3
      for (let i = 0; i < this.dataRecruit.length; i = i + 1) {
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
    },
    async handleCurrentChangeRecruit(val) {
      this.currentPageRecruit = val
      document.documentElement.scrollTop = 380
      if (this.idButtonRecruit === 1) {
        const { data: res } = await SelectRecruitName(this.nameRecruit, this.currentPageRecruit, this.pageSizeRecruit)
        this.dataRecruit = res.data[2]
        this.totalRecruit = res.data[0]
        for (let i = 0; i < this.dataRecruit.length; i = i + 1) {
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        }
      }
      if (this.idButtonRecruit === 2) {
        const { data: res } = await SelectRecruitCompany(this.companyRecruit, this.currentPageRecruit, this.pageSizeRecruit)
        this.dataRecruit = res.data[2]
        this.totalRecruit = res.data[0]
        for (let i = 0; i < this.dataRecruit.length; i = i + 1) {
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        }
      }
      if (this.idButtonRecruit === 3) {
        const { data: res } = await selectRecruit(this.idProvinceRecruit, this.currentPageRecruit, this.pageSizeRecruit)
        this.dataRecruit = res.data[2]
        this.totalRecruit = res.data[0]
        for (let i = 0; i < this.dataRecruit.length; i = i + 1) {
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.dataRecruit[i].content = this.dataRecruit[i].content.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        }
      }
    },
    async downloadRecruit(recruit) {
      const { data: res } = await filesDownloadByIdRecruit(recruit.id)
      // 下载文件
      const blob = new Blob([res])
      const objectUrl = URL.createObjectURL(blob) // 创建URL
      const link = document.createElement('a')
      link.href = objectUrl
      // 这里是获取后台传过来的文件名
      link.setAttribute('download', recruit.name + '.' + recruit.file.split('.')[recruit.file.split('.').length - 1])
      link.click() // 下载文件
      URL.revokeObjectURL(objectUrl) // 释放内存
    },
    async selectProjectFind() {
      const { data: res } = await selectProject(this.idProvinceProject, this.currentPageProject, this.pageSizeProject)
      this.dataProject = res.data[2]
      this.totalProject = res.data[0]
      this.idButtonProject = 3
      for (let i = 0; i < this.dataProject.length; i = i + 1) {
        this.dataProject[i].content = this.dataProject[i].content.replace(/\r\n/g, '<br/>')
        this.dataProject[i].content = this.dataProject[i].content.replace(/\r/g, '<br/>')
        this.dataProject[i].content = this.dataProject[i].content.replace(/\n/g, '<br/>')
      }
    },
    async companyProjectFind() {
      this.currentPageProject = 1
      const { data: res } = await SelectProjectCompany(this.companyProject, this.currentPageProject, this.pageSizeProject)
      this.dataProject = res.data[2]
      this.totalProject = res.data[0]
      this.idButtonProject = 2
      for (let i = 0; i < this.dataProject.length; i = i + 1) {
        this.dataProject[i].content = this.dataProject[i].content.replace(/\r\n/g, '<br/>')
        this.dataProject[i].content = this.dataProject[i].content.replace(/\r/g, '<br/>')
        this.dataProject[i].content = this.dataProject[i].content.replace(/\n/g, '<br/>')
      }
    },
    async nameProjectFind() {
      const { data: res } = await SelectProjectName(this.nameProject, this.currentPageProject, this.pageSizeProject)
      this.dataProject = res.data[2]
      this.totalProject = res.data[0]
      this.idButtonProject = 1
      for (let i = 0; i < this.dataProject.length; i = i + 1) {
        this.dataProject[i].content = this.dataProject[i].content.replace(/\r\n/g, '<br/>')
        this.dataProject[i].content = this.dataProject[i].content.replace(/\r/g, '<br/>')
        this.dataProject[i].content = this.dataProject[i].content.replace(/\n/g, '<br/>')
      }
    },
    async handleCurrentChangeProject(val) {
      this.currentPageProject = val
      document.documentElement.scrollTop = 380
      if (this.idButtonProject === 1) {
        const { data: res } = await SelectProjectName(this.nameProject, this.currentPageProject, this.pageSizeProject)
        this.dataProject = res.data[2]
        this.totalProject = res.data[0]
        for (let i = 0; i < this.dataProject.length; i = i + 1) {
          this.dataProject[i].content = this.dataProject[i].content.replace(/\r\n/g, '<br/>')
          this.dataProject[i].content = this.dataProject[i].content.replace(/\r/g, '<br/>')
          this.dataProject[i].content = this.dataProject[i].content.replace(/\n/g, '<br/>')
        }
      }
      if (this.idButtonProject === 2) {
        const { data: res } = await SelectProjectCompany(this.companyProject, this.currentPageProject, this.pageSizeProject)
        this.dataProject = res.data[2]
        this.totalProject = res.data[0]
        for (let i = 0; i < this.dataProject.length; i = i + 1) {
          this.dataProject[i].content = this.dataProject[i].content.replace(/\r\n/g, '<br/>')
          this.dataProject[i].content = this.dataProject[i].content.replace(/\r/g, '<br/>')
          this.dataProject[i].content = this.dataProject[i].content.replace(/\n/g, '<br/>')
        }
      }
      if (this.idButtonProject === 3) {
        const { data: res } = await selectProject(this.idProvinceProject, this.currentPageProject, this.pageSizeProject)
        this.dataProject = res.data[2]
        this.totalProject = res.data[0]
        for (let i = 0; i < this.dataProject.length; i = i + 1) {
          this.dataProject[i].content = this.dataProject[i].content.replace(/\r\n/g, '<br/>')
          this.dataProject[i].content = this.dataProject[i].content.replace(/\r/g, '<br/>')
          this.dataProject[i].content = this.dataProject[i].content.replace(/\n/g, '<br/>')
        }
      }
    },
    async downloadProject(project) {
      const { data: res } = await filesDownloadByIdProject(project.id)
      // 下载文件
      const blob = new Blob([res])
      const objectUrl = URL.createObjectURL(blob) // 创建URL
      const link = document.createElement('a')
      link.href = objectUrl
      // 这里是获取后台传过来的文件名
      link.setAttribute('download', project.name + '.' + project.file.split('.')[project.file.split('.').length - 1])
      link.click() // 下载文件
      URL.revokeObjectURL(objectUrl) // 释放内存
    },
    onSubmitMessage () {
      if (this.formMessageUpdate.name === '' || this.formMessageUpdate.phone === '') {
        this.$message({
          message: '姓名和电话不能为空',
          type: 'warning'
        })
      } else {
        this.$confirm('是否增加该留言信息?', '您好', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          // 上传数据
          const { data: res } = await insertMessage(this.formMessageUpdate)
          if (res.code === 200) {
            this.$message({
              message: '已增加该留言信息',
              type: 'success'
            })
          } else {
            this.$message({
              message: '增加该留言信息失败',
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消增加该留言信息'
          })
        })
      }
    },
    onClearMessage() {
      this.formMessageUpdate.name = ''
      this.formMessageUpdate.email = ''
      this.formMessageUpdate.phone = ''
      this.formMessageUpdate.content = ''
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a:hover {
  color: red;
}
p {
    margin-block-start: 0;
    margin-block-end: 0;
    text-align:justify;
}
a,p,div,span {
  font-size: 0.13rem;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.celebrity-content {
  width: 60%;
  float: left;
  margin: 0.1rem;
  margin-right: 0;
}

.content-input {
  margin: 0.1rem;
  margin-bottom: 0.05rem;
  .content-input-el {
    width: 1.8rem;
  }
}
.content-table {
  margin: 0.05rem 0.1rem 0.05rem 0.1rem;
}
.content-table-1 {
  padding-top: 0.02rem;
}
.content-table-11 {
  float: left;
  width: 6%;
  font-size: 0.13rem;
}
.content-table-12 {
  float: left;
  width: 94%;
}
/deep/ .el-collapse-item__header{
  padding-left: 0.06rem;
  font-size: 0.13rem;
}
/deep/ .el-collapse-item__header:hover {
  background-color: rgb(170, 255, 170);
}
/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}
.projects {
  float: right;
  width: 36%;
  margin-right: 0.2rem;
}
.projects-div {
  border: 1px dashed rgb(223, 221, 221);
  margin-left: 0;
  margin-right: 0.1rem;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  width: 100%;
  padding: 0.05rem;
}
.projects-div a:hover {
  color: blue;
}
.news {
  margin: 0.05rem;
  font-size: 0.17rem;
  font-weight: 700;
  text-align: center;
}
.projects-div-data {
  background-color: rgb(228, 252, 228);
}
.projects-div-data-name {
  border: 1px solid rgb(163, 252, 163);;
  margin-bottom: 0.05rem;
  padding: 0.06rem;
  border-radius: 0.05rem;
}
.projects-div-board {
  padding: 0.06rem;
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
.el-pagination {
  text-align: center;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio {
  margin-right: 0.07rem;
  margin-bottom: 0.05rem;
}
/deep/ .el-radio__label {
  padding-left: 0;
  font-size: 0.13rem;
}
/deep/ .el-tabs__nav-scroll {
  border-bottom: none;
}
/deep/ .el-tabs__item {
  height: 0.24rem;
  line-height: 0.24rem;
  font-size: 0.13rem;
}
/deep/ .el-tabs__header {
  margin: 0 0 0.02rem;
}
/deep/ .el-form-item__label {
  padding: 0;
  font-size: 0.13rem;
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
</style>
